import { SortingOrder } from 'src/modules/common/types';

export const DEFAULT_ROWS_PER_PAGE_COUNT = 5;
export const DEFAULT_ORDER_FIELD = 'facilityName';
export const DEFAULT_ORDER_DIRECTION = SortingOrder.ASC;
